import { useContext } from "react";

import SelectionValuesContext, { ISelectionValuesData } from "helpers/context/SelectionValues/SelectionValuesContext";

export function useSelectionValuesData(): ISelectionValuesData {
    return useContext(SelectionValuesContext);
};

export default useSelectionValuesData;
